import { AdminPlanningCycleBusinessGroupsForm, AdminPlanningCycleForm } from 'src/models/PlanningCycleFormModel';
import { EMPTY_DROPDOWN_OBJECT } from 'src/constants/generic-constants';
import {
  getCurrentMonthFirstDay,
  getCurrentMonthFirstDayLocalInISO,
  getLastMonthFirstDay,
  getLastMonthLastDay,
  getNextMonthLastDay,
  getNextMonthLastDayLocalInISO
} from 'src/utils/date-time-utilities';

/**
 * Scenario type ids from xpt.tbl_dim_scenarios.
 * R&O is the live scenario — cannot be closed or locked and serves as the baseline for all OP cycles.
 */
export const R_AND_O_SCENARIO_ID = 1;
export const OP_SCENARIO_ID = 2;

/**
 * Minimum forecast range (in months) required for a live (R&O) scenario.
 */
export const LIVE_SCENARIO_MIN_FORECAST_MONTHS = 48;

/**
 * Initial form state for the admin planning cycle form
 */
export const ADMIN_PLANNING_CYCLE_INITIAL_FORM: AdminPlanningCycleForm = {
  scenario: EMPTY_DROPDOWN_OBJECT,
  scenario_year: '',
  original_scenario_year: '',
  planning_cycle_name: EMPTY_DROPDOWN_OBJECT,
  planning_cycle_year: EMPTY_DROPDOWN_OBJECT,
  business_groups: []
};

/**
 * List of business group fields for validation and processing
 */
export const BUSINESS_GROUP_FIELDS = [
  'data_classification',
  'baseline_scenario',
  'actuals_date_range',
  'forecast_date_range',
  'prophecy_actuals_date_range',
  'prophecy_forecast_date_range',
  'planning_cycle_date_time_range'
] as const;

/**
 * Initial state for a new business group in the planning cycle form
 */
export const initialBusinessGroup: AdminPlanningCycleBusinessGroupsForm = {
  scenario_seq_id: null,
  forecast_data_available: false,
  data_classification: EMPTY_DROPDOWN_OBJECT,
  baseline_scenario: EMPTY_DROPDOWN_OBJECT,
  actuals_date_range: { type: 'absolute', startDate: getLastMonthFirstDay(), endDate: getLastMonthLastDay() },
  forecast_date_range: { type: 'absolute', startDate: getCurrentMonthFirstDay(), endDate: getNextMonthLastDay() },

  prophecy_actuals_date_range: { type: 'absolute', startDate: getLastMonthFirstDay(), endDate: getLastMonthLastDay() },
  prophecy_forecast_date_range: { type: 'absolute', startDate: getCurrentMonthFirstDay(), endDate: getNextMonthLastDay() },
  // Blank by default → all forecast months editable (backward compatible). R&O scenario only.
  budget_editable_date_range: undefined,
  planning_cycle_date_time_range: { type: 'absolute', startDate: getCurrentMonthFirstDayLocalInISO(), endDate: getNextMonthLastDayLocalInISO() },

  budget_owner_lock_date: '',
  budget_owner_lock_date_picker_value: '',
  budget_owner_lock_time_picker_value: '',

  is_prophecy_enabled: false,
  last_synced_to_prophecy: null,
  prophecy_created_at: null,
  prophecy_created_by: null,

  is_active: true,
  created_at: '',
  created_by: '',
  updated_at: '',
  updated_by: '',
  planning_cycle_extended_date_picker_value: '',
  planning_cycle_extended_time_picker_value: '',
  is_extended: false,
  planning_cycle_extended_date: '',
  extended_users: [],
  // Off by default. Only relevant for OP scenarios; ignored for R&O.
  is_budget_leader_owner_editable: false
};
